var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    {
      ref: "box",
      staticClass: "baseContainer",
      attrs: { id: "app" },
      on: { scroll: _vm.scrollEvent },
    },
    [
      false
        ? _c("div", { staticClass: "screen-width" }, [
            _vm._v(_vm._s(_vm.screenWidth)),
          ])
        : _vm._e(),
      _c("router-view"),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }